










import { Employe } from "../../models/Employe";
import Planning = Employe.Planning;

export default {
    name: "PlanningListDayDetail",
    props: {
        day: Employe.EWorkingHourDay,
        planning: Planning,
    },
    data() {
        return {
            workingHours: [],
        };
    },
    methods: {
        updateWorkingHours() {
            let self = this;
            self.workingHours = _.filter(
                self.planning.planning_working_hours,
                function (workingHour) {
                    return workingHour.jour === self.day;
                }
            );
        },
    },
    watch: {
        planning: {
            immediate: true,
            handler() {
                this.updateWorkingHours();
            },
        },
    },
};
